import { render, staticRenderFns } from "./FormLaskuMitatoi.vue?vue&type=template&id=2c4bed91&scoped=true&"
import script from "./FormLaskuMitatoi.vue?vue&type=script&lang=js&"
export * from "./FormLaskuMitatoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4bed91",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c4bed91')) {
      api.createRecord('2c4bed91', component.options)
    } else {
      api.reload('2c4bed91', component.options)
    }
    module.hot.accept("./FormLaskuMitatoi.vue?vue&type=template&id=2c4bed91&scoped=true&", function () {
      api.rerender('2c4bed91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormLaskuMitatoi.vue"
export default component.exports